import React, { Component } from "react";
import classNames from "classnames";

export default class ButtonGroup extends Component {
    render() {
        const buttons = this.props.buttons.map(button => {
            const activeClass = this.props.value === button.value ? "active" : "";
            return (
                <button key={button.value}
                        type="button"
                        className={classNames(activeClass, button.className, `x-${button.value}`)}
                        data-test-locator={button.value}
                        onClick={() => this.props.onChange(button.value)}>
                    {button.label}
                </button>);
        });

        return (
            <div className={ classNames("ButtonGroup", this.props.className) }
                 style={{ display: "inline-block", backgroundColor: "white" }}>
                {buttons}
            </div>
        );
    }
}

ButtonGroup.propTypes = {
    buttons: React.PropTypes.arrayOf(React.PropTypes.shape({
        label: React.PropTypes.string.isRequired,
        value: React.PropTypes.string.isRequired
    })).isRequired,
    className: React.PropTypes.string,
    onChange: React.PropTypes.func,
    value: React.PropTypes.string
};



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/ButtonGroup.js
 **/